var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"36.7696","y":"74","width":"52.388","height":"52.388","transform":"rotate(-45 36.7696 74)","stroke":"#EBEE00","strokeWidth":"52"}));
}

Diamond.defaultProps = {"width":"148","height":"148","viewBox":"0 0 148 148","fill":"none"};

module.exports = Diamond;

Diamond.default = Diamond;
